import React from 'react';

import { SavedListsModalComponent } from './SavedListsModal.component';
import {
  SavedListsModalProvider,
  useSavedListsModal,
} from './SavedListsModal.context';
import { SavedListsModalProps } from './SavedListsModal.types';

export const SavedListsModal: React.FC<SavedListsModalProps> = (props) => {
  const context = useSavedListsModal(props);
  return (
    <SavedListsModalProvider value={context}>
      <SavedListsModalComponent />
    </SavedListsModalProvider>
  );
};
